import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Input, Select, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { fetchBrandList } from '../../apis/brand'
import { fetchGroupList } from '../../apis/group'
import { SearchWrapper } from '../DataSource/dataSource.styled'
import useParams from '../../hook/useParams'
import { WhiteWrapper } from './group.styled'
import ClientUserTable from './ClientUserTable'
import AddUserModal from './modals/AddUserModal'
import AdminUserTable from './AdminUserTable'

function UserList (props) {
  const { adminMode, brand, setBrand, group, setGroup } = props
  const { t: ln_t } = useTranslation()
  const user = useSelector((state) => state.user)
  const params = useParams({ groupId: user?.nowGroup, brandId: brand })
  const { handleFetchParams, fetchParams } = params
  const userGroupOptions = user?.groups?.map(i => ({ value: i.id, label: i.name })) || []

  const [brandsOption, setBrandsOption] = useState([])
  const [groupsOption, setGroupsOption] = useState(userGroupOptions)
  const [addUser, setAddUser] = useState(false)

  const brandRoleOptions = [{ value: 'admin', label: ln_t('util.role.admin') }, { value: 'member', label: ln_t('util.role.member') }]

  const addUserSuccessCallback = () => {
    message.success(ln_t('message.success.add'))
    handleFetchParams('add', {})
  }

  const getBrands = async () => {
    const result = await fetchBrandList({ maxResults: 1000, sort: '-updatedAt', groupId: adminMode ? undefined : user.nowGroup })
    if (result.status === 200) setBrandsOption(result?.data.map(i => ({ value: i.id, label: i.name, groupId: i.groupId })))
  }
  const getGroups = async () => {
    const result = await fetchGroupList({ maxResults: 1000, sort: '-updatedAt' })
    if (result?.status === 200) setGroupsOption(result?.data.map(i => ({ value: i.id, label: i.name })))
  }

  useEffect(() => {
    if (fetchParams?.brandId === brand) return
    handleFetchParams('add', { brandId: brand })
  }, [brand])

  useEffect(() => {
    if (fetchParams?.groupId === group && (!adminMode && fetchParams?.groupId === user?.nowGroup)) return
    handleFetchParams('add', { groupId: adminMode ? group : user?.nowGroup })
  }, [group])

  useEffect(() => {
    if (adminMode) getGroups()
    getBrands()
  }, [adminMode])

  const passProps = { adminMode, params, brandRoleOptions, groupsOption, brandsOption }
  return (
    <WhiteWrapper>
      <h3>{ln_t('group.user')}</h3>
      <SearchWrapper>
        <div style={{ display: 'flex' }}>
          <Input.Search
            allowClear
            style={{ width: '400px' }}
            placeholder={ln_t('util.search')}
            onSearch={e => handleFetchParams('add', { name: `%${e}%` })}
            enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
          />
          {adminMode
            ? <div className="d-flex">
                <div style={{ fontSize: '14px', fontWeight: 500, margin: 'auto 8px' }}>{ln_t('util.group')} :</div>
                <Select
                  showSearch
                  style={{ minWidth: '120px' }}
                  defaultValue="all"
                  placeholder={`${ln_t('util.select')} ${ln_t('util.group')}`}
                  options={[{ value: 'all', label: 'ALL' }, ...groupsOption]}
                  optionFilterProp="children"
                  value={group || 'all'}
                  onChange={e => setGroup(e === 'all' ? undefined : e)}
                />
              </div>
            : ''}
            <div className="d-flex">
              <div style={{ fontSize: '14px', fontWeight: 500, margin: 'auto 8px' }}>{ln_t('util.brand')} :</div>
              <Select
                showSearch
                style={{ minWidth: '120px' }}
                defaultValue="all"
                placeholder={`${ln_t('util.select')} ${ln_t('util.brand')}`}
                options={[{ value: 'all', label: 'ALL' }, ...brandsOption]}
                optionFilterProp="children"
                value={brand || 'all'}
                onChange={e => setBrand(e === 'all' ? undefined : e)}
              />
            </div>
        </div>
        <Button type="default" icon={<PlusOutlined />} onClick={() => setAddUser(true)}>
          {ln_t('util.add')} {ln_t('group.user')}
        </Button>
      </SearchWrapper>

      {adminMode ? <AdminUserTable {...passProps} /> : <ClientUserTable {...passProps} />}

      <AddUserModal
        {...passProps}
        show={addUser}
        setShow={setAddUser}
        successCallback={addUserSuccessCallback}
      />
    </WhiteWrapper>
  )
}

export default UserList
